import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { ILogin } from "../../models/Login";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { ISubvendorInvoiceList } from "../subVendorInvoices/Table";
import { format } from "date-fns";

const Payment = (props: any) => {
  const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: ISubvendorInvoiceList[], loading: boolean });
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');

  const onHide = () => {
    props.hideDialog();
    // reset();
    // setSelectedDocuments([]);
  };
  const loadPaymentInvoices = async () => {
    setTableData({ tableData: tableData.tableData, loading: true });
    const response = await Fetch("ResourceInvoices/subvendorInvoice", "GET", null, `poID=${loginObj.pOs[0].pO_ID}`, null);
    if (response) {
      const data = await response.json();
      setTableData({ tableData: data, loading: false });
    } else {
      setTableData({ tableData: tableData.tableData, loading: false });
    }
  }

  const getDate = (date: any) => {
    let datee;
    datee = format(new Date(date), 'MM/dd/yyyy').toUpperCase();
    return (<>{datee || ""}</>);
  };

  const downLoadInvoice = async (rowData: ISubvendorInvoiceList) => {
    const params = {
      method: "GET",
      headers: {
        'Content-Type': 'application/pdf',
        'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
      }
    };
    try {
      const response = await fetch(`${baseUrl}${"InvoiceTracking/downloadSubvendor"}?path=${rowData.invoicePath}`, params);
      if (response.status === 200) {
        const blob = await response.blob();
        const href = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.download = `${rowData?.invoiceNO}.pdf`;
        a.href = href;
        a.click();
        a.href = '';
      } else if (response.status === 400) {
        const message = await response.text();
        props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
      }
    } catch {
      props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
    }
  };

  const svInvoice = (rowData: ISubvendorInvoiceList) => {
    return <p className="cursor-pointer text-cyan-700 underline" style={{ cursor: "pointer" }} onClick={() => downLoadInvoice(rowData)}>{rowData.invoiceNO}</p>
  };

  useEffect(() => {
    if (props.open) {
      loadPaymentInvoices();
    }
  }, [props.open]);

  return (
    <Dialog visible={props.open} style={{ width: "80vw" }} header="My Payments" modal className="p-fluid" onHide={onHide}>
      <div>
        <Card title="Payments">
          <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
            value={tableData.tableData}
            loading={tableData.loading}
            // selection={selectedBenchs}
            stripedRows resizableColumns showGridlines columnResizeMode="expand"
            // onSelectionChange={(e) => setSelectedBenchs(e.value)}
            // selectionMode="multiple"
            dataKey="invoice_ID"
            paginator
            rows={10}
            rowsPerPageOptions={[5, 10, 20]}
          >
            {/* <Column selectionMode="multiple" /> */}
            <Column header="SN." body={(rowData, options) => options.rowIndex + 1} />
            <Column field="consultant_Name" header="Name" />
            <Column field="vendor_Company_Name" header="Sub Vendor" />
            {/* <Column field="invoiceNO" header="Invoice#" body={(rowData: ISubvendorInvoiceList) => svInvoice(rowData)} /> */}
            <Column field="invoiceNO" header="Invoice#" />
            <Column field="invoiceDate" header="Invoice Date" body={(rowData) => getDate(rowData.invoiceDate)} />
            <Column field="fromDate" header="From Date" body={(rowData) => getDate(rowData.fromDate)} />
            <Column field="toDate" header="To Date" body={(rowData) => getDate(rowData.toDate)} />
            <Column field="dueDate" header="Due Date" body={(rowData) => getDate(rowData.dueDate)} />
            <Column field="workingHours" header="Hours" />
            {/* <Column field="bRate" header="B.Rate" /> */}
            {/* <Column field="invoiceAmount" header="Inv.Amount" /> */}
            {/* <Column field="requestedAmount" header="Requested Amount" /> */}
            {/* <Column field="paidAmount" header="Paid Amount" /> */}
            {/* <Column field="payment_Mode" header="Payment Mode" /> */}
            {/* <Column field="transaction_ID" header="Transaction" /> */}
            <Column field="payment_Date" header="Payment Date" body={(rowData) => getDate(rowData.payment_Date)} />
            <Column field="paymentStatus" header="Payment Status" />
          </DataTable>
        </Card>
      </div>
    </Dialog>
  );
};

export default Payment;
